import { useShallow } from 'zustand/react/shallow';

import { ADMIN_SECTIONS } from '../constants/adminSections';
import { useStore } from '../store';

export interface AdminSectionAccess {
  canView: boolean;
  canEdit: boolean;
}

/**
 * Read/write access to one Admin-tab section.
 *
 * Each section owns a view/edit slug pair. `canView` is true for either, because
 * a grant to edit something that cannot be displayed is useless. Sections call
 * this themselves rather than taking a prop so that a section rendered outside
 * the Admin tab still gets the right answer.
 */
export function useAdminSectionAccess(sectionId: string): AdminSectionAccess {
  const { hasAnyPermission } = useStore(
    useShallow(state => ({
      hasAnyPermission: state.hasAnyPermission,
    }))
  );

  const section = ADMIN_SECTIONS.find(entry => entry.id === sectionId);
  if (!section) {
    throw new Error(`Unknown admin section: ${sectionId}`);
  }

  return {
    canView: hasAnyPermission([section.viewSlug, section.editSlug]),
    canEdit: hasAnyPermission([section.editSlug]),
  };
}
